import React from 'react';
import WorkspacesView from './views/WorkspacesView';
import { useWorkspaces } from './hooks/Workspaces.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const WorkspacesController = () => {
  const { loading, error, handleSubmit, goToWorkspaceMap } = useWorkspaces();
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const onWorkspaces = async values => {
    console.log('Simulated workspaces:', values);
    window.location.href = '/dashboard';
  };

  return (
    <WorkspacesView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onWorkspaces)}
      loading={loading}
      error={error}
      languageData={languageData}
      goToWorkspaceMap={goToWorkspaceMap}
    />
  );
};

export default WorkspacesController;
